import deleteFilled from "../../assets/icons/signage-plus/delete-filled.svg";

function DeleteButton({ onClick }) {
  return (
    <button
      className="btn btn-no-border"
      id="deletePlaylist"
      onClick={onClick}
    >
      <img src={deleteFilled} className='icon icon-24' alt="delete" />
    </button>
  );
}

export default DeleteButton;
